/* src/app/forms/produtos/amazon/amazon.component.css */
:host {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=amazon.component.css.map */
